import { EventConsts } from 'client/util/Constants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import LocalStorageService from 'client/util/LocalStorageService';
import MspState from 'components/models/MspState';
import PageNavigationUtil from 'client/util/PageNavigationUtil';
import Util from 'client/util/Util';
import util from 'client/util';

export default {
  /**
   * Handles all the event and local storage removals that need to happen upon logout.
   * @see {@link test/jest.init.js}--this file is globally mocked
   * @return {String} - The logout url that should be used
   */
  handleLogout() {
    this.handleCleanup();

    // Check for disabled command runner return param
    let logoutStr = '/logout';
    const returnParam = util.getUrlParameter('ret');
    if (returnParam) {
      logoutStr = `${logoutStr}?ret=${returnParam}`;
    }
    Util.redirect(logoutStr);
  },

  handleCleanup() {
    EventHelper.triggerLogOutClicked();

    // Clear cookies from Drift chat
    if (window && window.drift) {
      window.drift.reset();
    }

    // Clear local storage visitorId for Optimizely
    LocalStorageService.removeItem('visitorId');

    MspState.clearStorage();

    // Trigger a logout in all open tabs and then remove
    // so it doesn't pollute localStorage
    LocalStorageService.setItem(EventConsts.logoutEvent, true);
    LocalStorageService.removeItem(EventConsts.logoutEvent);

    // Remove event handlers prior to navigating to the /logout page because if
    // unsaved changes are present in an aside panel the admin user was already
    // warned of them when navigating to #/logout. The #/logout hash is
    // handled here, /logout is handled by SI to actually remove the admin
    // user's session and redirect to the /login page.
    PageNavigationUtil.removeEventHandlers();
  },
};
